import script from "./AutoLabSpeed.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoLabSpeed.vue?vue&type=script&setup=true&lang=js"

import "./AutoLabSpeed.vue?vue&type=style&index=0&id=71db5603&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71db5603"]])

export default __exports__